import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'

const contragentTypeDict: Array<Dictionary> = []

enum contragentTypes {
 none = 'none',
 legal = 'legal_entity',
 individual = 'individual'
}

for (const code of Object.values(contragentTypes)) {
    contragentTypeDict.push(
        {
            code,
            name: i18n.t(`dictionary.contragentType.${code}`).toString()
        }
    )
}

export { contragentTypes, contragentTypeDict }
